import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import React, { useEffect } from 'react';
import { getFunnelStepperConfig } from '../funnelSteps';
import './RequireConsultation.scss';
import { trackMixpanelPageView } from '@helpers/post';

const HUBSPOT_PORTAL_ID = process.env.REACT_APP_HS_CONSULTATION_PORTAL_ID || '50706065';
const HUBSPOT_FORM_ID =
  process.env.REACT_APP_HS_CONSULTATION_FORM_ID_BSL || '35491830-c643-4809-a448-5b8a1d9610d2';
const HUBSPOT_REGION = process.env.REACT_APP_HS_CONSULTATION_REGION || 'na1';

const loadHubSpotConsultationForm = () => {
  if (!HUBSPOT_PORTAL_ID && !HUBSPOT_FORM_ID) return;

  window.hbspt.forms.create({
    region: HUBSPOT_REGION,
    portalId: HUBSPOT_PORTAL_ID,
    formId: HUBSPOT_FORM_ID,
    target: `#hs-form-${HUBSPOT_FORM_ID}`,
  });
};

export const RequireConsultation = () => {
  const funnelStepper = getFunnelStepperConfig('/create-account/request-consultation');

  useEffect(() => {
    trackMixpanelPageView('/create-account/request-consultation');
    loadHubSpotConsultationForm();
  }, []);

  return (
    <div className="require-consultation">
      <main>
        {funnelStepper && (
          <div className="next-steps-mobile-stepper">
            <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
          </div>
        )}
        <header>
          <div className="screen-title gotham-bold-font">Request a Consultation</div>
        </header>

        <div>
          Long-term placements get a personalized approach. A Go4 staffing specialist will reach out within 1
          business day.
        </div>

        <div className="bsl-form-section" id="get-started">
          <div className="bsl-form-wrap">
            <div
              className="hs-form-frame bsl-hubspot-form"
              data-region={HUBSPOT_REGION}
              data-form-id={HUBSPOT_FORM_ID}
              data-portal-id={HUBSPOT_PORTAL_ID}
              id={`hs-form-${HUBSPOT_FORM_ID}`}
            />
          </div>
        </div>
      </main>
    </div>
  );
};
